import Cache from '@services/Cache';
import apiClient from '@services/ApiClient';
import PrinterRepository from '@services/repositories/Printer/PrinterRepository';
import { hasRole } from '@services/Helpers';

export default class BackendRepository {
    static getCauseCodes() {
        if (!Cache.get('user-cause-codes')) {
            return apiClient.get('/vue/users/cause_codes')
                .then((response) => {
                    Cache.set('user-cause-codes', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('user-cause-codes'));
    }

    static getStores() {
        if (!Cache.get('stores')) {
            return apiClient.get('/vue/stores/list')
                .then((response) => {
                    Cache.set('stores', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('stores'));
    }

    static getStatuses() {
        if (!Cache.get('statuses')) {
            return apiClient.get('/vue/statuses/list')
                .then((response) => {
                    Cache.set('statuses', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('statuses'));
    }

    static getLanguages() {
        if (!Cache.get('languages')) {
            return apiClient.get('/vue/languages/list')
                .then((response) => {
                    Cache.set('languages', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('languages'));
    }

    static getBranding() {
        if (!Cache.get('branding')) {
            return apiClient.get('/vue/branding/list')
                .then((response) => {
                    Cache.set('branding', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('branding'));
    }

    static getFlags() {
        if (!Cache.get('flags')) {
            return apiClient.get('/vue/flags/list')
                .then((response) => {
                    Cache.set('flags', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('flags'));
    }

    static getProductRangeFlags() {
        if (!Cache.get('product-range-flags')) {
            return apiClient.get('/vue/product_range/flags')
                .then((response) => {
                    Cache.set('product-range-flags', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('product-range-flags'));
    }

    static getProductRangeCategories() {
        if (!Cache.get('product-range-categories')) {
            return apiClient.get('/vue/product_range/categories')
                .then((response) => {
                    Cache.set('product-range-categories', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('product-range-categories'));
    }

    static getCardSeriesTypes() {
        if (!Cache.get('card-series-types')) {
            return apiClient.get('/vue/cardseries/types')
                .then((response) => {
                    Cache.set('card-series-types', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('card-series-types'));
    }

    static getCardSeriesPriceCategories() {
        if (!Cache.get('card-series-price-categories')) {
            return apiClient.get('/vue/cardseries/price_categories')
                .then((response) => {
                    Cache.set('card-series-price-categories', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('card-series-price-categories'));
    }

    static getCustomerGroups() {
        if (!Cache.get('customer-groups')) {
            return apiClient.get('/vue/customers/groups')
                .then((response) => {
                    Cache.set('customer-groups', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('customer-groups'));
    }

    static getCustomerStatuses() {
        if (!Cache.get('customer-statuses')) {
            return apiClient.get('/vue/customers/statuses')
                .then((response) => {
                    Cache.set('customer-statuses', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('customer-statuses'));
    }

    static getAccounts() {
        if (!Cache.get('bookkeeping-accounts')) {
            return apiClient.get('/vue/economy/accounts')
                .then((response) => {
                    Cache.set('bookkeeping-accounts', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('bookkeeping-accounts'));
    }

    static getCalendarTypes() {
        if (!Cache.get('calendar-types')) {
            return apiClient.get('/vue/dashboard/calendar/types')
                .then((response) => {
                    Cache.set('calendar-types', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('calendar-types'));
    }

    static getCurrencies() {
        if (!Cache.get('currencies')) {
            return apiClient.get('/vue/currencies/list')
                .then((response) => {
                    Cache.set('currencies', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('currencies'));
    }

    static getVatTypes() {
        if (!Cache.get('vat-types')) {
            return apiClient.get('/vue/vat_types/list')
                .then((response) => {
                    Cache.set('vat-types', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('vat-types'));
    }

    static getCardOrderOrderStatuses() {
        if (!Cache.get('card-order-order-statuses')) {
            return apiClient.get('/vue/cardorders/order_statuses')
                .then((response) => {
                    Cache.set('card-order-order-statuses', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('card-order-order-statuses'));
    }

    static getCardOrderPaymentStatuses() {
        if (!Cache.get('card-order-payment-statuses')) {
            return apiClient.get('/vue/cardorders/payment_statuses')
                .then((response) => {
                    Cache.set('card-order-payment-statuses', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('card-order-payment-statuses'));
    }

    static getCardOrderDeliveryStatuses() {
        if (!Cache.get('card-order-delivery-statuses')) {
            return apiClient.get('/vue/cardorders/delivery_statuses')
                .then((response) => {
                    Cache.set('card-order-delivery-statuses', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('card-order-delivery-statuses'));
    }

    static getCardOrderPaymentMethods() {
        if (!Cache.get('card-order-payment-methods')) {
            return apiClient.get('/vue/cardorders/payment_methods')
                .then((response) => {
                    Cache.set('card-order-payment-methods', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('card-order-payment-methods'));
    }

    static getBrands() {
        if (!Cache.get('brands')) {
            return apiClient.get('/vue/product_brands?per_page=1000')
                .then((response) => {
                    Cache.set('brands', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('brands'));
    }

    static getMediabankCategories() {
        if (!Cache.get('mediabank-categories')) {
            return apiClient.get('/vue/mediabank/categories?per_page=1000')
                .then((response) => {
                    Cache.set('mediabank-categories', response.data.data);
                    return response.data.data;
                });
        }

        return Promise.resolve(Cache.get('mediabank-categories'));
    }

    static getSalesCrmUsers() {
        if (!Cache.get('sales-crm-users')) {
            return apiClient.get('/vue/sales/crm/select_users')
                .then((response) => {
                    Cache.set('sales-crm-users', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('sales-crm-users'));
    }

    static getSalesCrmCompanies() {
        if (!Cache.get('sales-crm-companies')) {
            return apiClient.get('/vue/sales/crm/select_companies')
                .then((response) => {
                    Cache.set('sales-crm-companies', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('sales-crm-companies'));
    }

    static getSalesCrmStrings() {
        if (!Cache.get('sales-crm-strings')) {
            return apiClient.get('/vue/sales/crm/select_strings')
                .then((response) => {
                    Cache.set('sales-crm-strings', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('sales-crm-strings'));
    }

    static getEcardTemplateFonts() {
        if (!Cache.get('ecard-template-fonts')) {
            return apiClient.get('/vue/ecard/fonts')
                .then((response) => {
                    Cache.set('ecard-template-fonts', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('ecard-template-fonts'));
    }

    static getPrintFormats() {
        if (!Cache.get('print-formats')) {
            return apiClient.get('/vue/prepress/print_formats')
                .then((response) => {
                    Cache.set('print-formats', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('print-formats'));
    }

    static getKorrFormats() {
        if (!Cache.get('korr-formats')) {
            return apiClient.get('/vue/prepress/korr_formats')
                .then((response) => {
                    Cache.set('korr-formats', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('korr-formats'));
    }

    static getLabelBatchStatuses() {
        if (!Cache.get('label-batch-statuses')) {
            return apiClient.get('/vue/shipping/label_batch/statuses')
                .then((response) => {
                    Cache.set('label-batch-statuses', response.data);
                    return response.data;
                });
        }

        return Promise.resolve(Cache.get('label-batch-statuses'));
    }

    static getSmallLabelPrinters() {
        if (!Cache.get('small-label-printers')) {
            const client = new PrinterRepository();
            client.whereIn('media', ['adr_101x38', 'adr_99x49'])
                .where('language', 'zpl')
                .orderBy('name')
                .orderDirection('ASC')
                .setPerPage(999999);

            if (!hasRole('super-admin')) {
                client.where('is_dev', 0);
            }

            return client.run().then((response) => {
                Cache.set('small-label-printers', response.data);
                return response.data;
            });
        }

        return Promise.resolve(Cache.get('small-label-printers'));
    }
}
